import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { Encoding } from '../components/wizard-ui/types/types';

interface PresentState {
    holderPrivateKey: string;
    holderPrivateKeyEncoding: Encoding;
    credentials: string[];
    masks: any[];
    inputComponentList: number[];
    vp: string;
}

const initialState: PresentState = {
    holderPrivateKey: '9b47b07b509e2e75bf2866ffa459c85162146199882c065301751a6e58c84799',
    holderPrivateKeyEncoding: 'Hex',
    credentials: [''],
    masks: [{}],
    inputComponentList: [0],
    vp: ''
};

export const presentSlice = createSlice({
    name: 'present',
    initialState,
    reducers: {
        setHolderPrivateKey: (state, action: PayloadAction<string>) => {
            state.holderPrivateKey = action.payload;
        },
        setHolderPrivateKeyEncoding: (state, action: PayloadAction<Encoding>) => {
            state.holderPrivateKeyEncoding = action.payload;
        },
        setCredentials: (state, action: PayloadAction<any>) => {
            state.credentials = action.payload;
        },
        setMasks: (state, action: PayloadAction<any>) => {
            state.masks = action.payload;
        },
        setInputComponentList: (state, action: PayloadAction<number[]>) => {
            state.inputComponentList = action.payload;
        },
        setVP: (state, action: PayloadAction<string>) => {
            state.vp = action.payload;
        }
    }
});

export const { setHolderPrivateKey, setHolderPrivateKeyEncoding, setCredentials, setInputComponentList, setVP, setMasks } =
    presentSlice.actions;

export const _holderPrivateKey = (state: RootState) => state.present.holderPrivateKey;
export const _holderPrivateKeyEncoding = (state: RootState) => state.present.holderPrivateKeyEncoding;
export const _credentials = (state: RootState) => state.present.credentials;
export const _masks = (state: RootState) => state.present.masks;
export const _inputComponentList = (state: RootState) => state.present.inputComponentList;
export const _vp = (state: RootState) => state.present.vp;

export default presentSlice.reducer;
